export default __webpack_public_path__ + "static/media/green_emphasize_spot.6cc1399e.svg";